import React from 'react'
import { Form } from '../Form/Form'

export const SearchArea = ({cocktail,setCocktail,text,setText,fetchCocktail,handleSubmit,showId}) => {
console.log(fetchCocktail)
  return (
    <div className=' text-3xl'>
     <h1> Find your favourite cocktails</h1>
      <div>
       <Form 
       cocktail={cocktail}
       setCocktail={setCocktail}
       text={text}
       setText={setText}
       fetchCocktail={fetchCocktail}
       handleSubmit={handleSubmit}
       showId={showId}
       />
       
      </div>

      
    </div>
  )
}
